import React from 'react';
import LegalPageTemplate from '../../components/legal/LegalPageTemplate';

const TermsPage: React.FC = () => {
  return <LegalPageTemplate sectionKey="terms" />;
};

export default TermsPage;